<div class="PolicyDashboard">
    <div class="Loading"  *ngIf="isShowLoading==true">
        <img id="" src="assets/img/762.gif"   />
        <label>{{'Please Wait,Processing..'|translate }}</label>
    </div>

    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-2 col-md-2 hidden-sm hidden-xs"></div>
            <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">
                <div class="col-md-12 proposals">
                    <div class="panel panel-default panel-table">
                        <div class="panel-heading">
                            <div class="row Field">
                                <div class="col col-xs-12">
                                    <h3 class="panel-title">{{'Payment Gateway' | translate }}</h3>
                                </div>
                            </div>
                        </div>
                        <div class="panel-body">
                            <div class="PaymentForm">
                                <div class="row Field">
                                    <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                        <label>{{'Proposal Number' | translate }}</label>
                                    </div>
                                    <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">
                                        <input type="text" class="form-control" [disabled]="true" name="txtProposalNo" id="txtProposalNo" [(ngModel)]="ProposalNo">
                                    </div>
                                </div>
                                <div class="row Field">
                                    <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                        <label>{{'Name' | translate }}</label>
                                    </div>
                                    <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">
                                        <input type="text" class="form-control" [disabled]="true" name="txtName" id="txtName" [(ngModel)]="InsuredName">
                                    </div>
                                </div>
                                <div class="row Field">
                                    <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                        <label>{{'Premium(SAR)'| translate }}</label>
                                    </div>
                                    <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">
                                        <input type="text" class="form-control" [disabled]="true" name="txtPremium" id="txtPremium" [ngModel]="TotalPremium | number : '1.2-2'">
                                    </div>
                                </div>
                                <div class="row Field" style="margin:30px 0px;">
                                    <label style="margin: 0 auto;">{{'Select Payment Type' | translate }}</label>
                                </div>
                                <div class="row Field">
                                    <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                        <label class="paymentmethodlabel">{{'Mada' | translate }}</label>
                                    </div>
                                    <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">
                                        <div class="row paymentimg">
                                            <input type="radio" class="radio_item radio_item_Ar" [(ngModel)]="PMethod" value="MD"
                                           name="item" id="radio3">
                                            <label class="label_item" for="radio3">
                                                <img src="assets/img/mada.png" height="50px" width="140px" style="margin-top:8px; margin-left:8px;"> 
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div class="row Field">
                                    <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                        <label class="paymentmethodlabel">{{'Visa/Master' | translate }}</label>
                                    </div>
                                    <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">
                                        <div class="row paymentimg">
                                            <input type="radio" class="radio_item radio_item_Ar" [(ngModel)]="PMethod" value="CR"
                                            name="item" id="radio1">
                                            <label class="label_item" for="radio1">
                                                <img src="assets/img/visaandmaster.png" height="50px" width="140px" style="margin-top:8px; margin-left:8px;"> 
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <!-- <div class="row Field">
                                    <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                        <label class="paymentmethodlabel">{{'SADAD Bill' | translate }}</label>
                                    </div>
                                    <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">
                                        <div class="row paymentimg">
                                            <input type="radio" class="radio_item radio_item_Ar" [(ngModel)]="PMethod" value="SDB"
                                              name="item" id="radio4">
                                            <label class="label_item" for="radio4">
                                                <img src="assets/img/sadad_biller.jpg" height="50px" width="140px" style="margin-top:8px; margin-left:8px;"> 
                                            </label>
                                        </div>
                                    </div>
                                </div> -->
                                <!-- <div class="row Field">
                                    <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                        <label class="paymentmethodlabel">{{'SADAD Account' | translate }}</label>
                                    </div>
                                    <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">
                                        <div class="row paymentimg">
                                            <input type="radio" class="radio_item radio_item_Ar" [(ngModel)]="PMethod" value="SD"
                                            name="item" id="radio2">
                                            <label class="label_item" for="radio2">
                                                <img src="assets/img/sadad1.png" height="50px" width="140px" style="margin-top:8px; margin-left:8px;"> 
                                            </label>
                                        </div>
                                    </div>
                                </div> -->
                                
                                <div class="row">
                                    <div class="col-lg-9">
                                        <span class="aggree">
                                            <span> <input type="checkbox"id="Chkterms" name="Chkterms" class="agreeTerms" [(ngModel)]="agreeTerms"  style=" zoom: 1.5;" /></span>
                                            <span><a  href="{{this.url.DocumentURL}}Downloads/termsandcondition.pdf" style="font-weight:bold;" target="_balnk" download="PolicyTermsandConditions">{{'I Agree to Policy Terms and Conditions' | translate}}</a></span>
                                        </span>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="buttonpay">
                                        <button class="btn btn-primary " name="btnProceed" id="btnProceed" [disabled]="!agreeTerms || PMethod==null" (click)="GetPamentRequestDetails_Upgrade()" >{{'Proceed To Pay' | translate }}</button>
                                        <button class="btn btn-primary " name="btnCancel" id="btnCancel">{{'Cancel' | translate }}</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-2 col-md-2 hidden-sm hidden-xs"></div>
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/PayfortUpgrade/PayfortPaymentUpgrade/PayfortPaymentUpgrade.html